import Flickity from 'flickity';

const carousels = document.querySelectorAll('.blog-posts');
let activeCarousels = [];
const carouselOptions = {
    cellAlign: 'left',
    prevNextButtons: false,
    contain: false,
    wrapAround: false,
    arrowShape: "M 72.37 97.59 C 70.96 97.59 69.55 97.03 68.42 95.9 L 26.69 53.6 C 24.43 51.34 24.43 47.96 26.69 45.7 L 68.42 3.69 C 70.68 1.43 74.06 1.43 76.32 3.69 C 78.58 5.95 78.58 9.33 76.32 11.59 L 38.53 49.65 L 76.32 88 C 78.58 90.26 78.58 93.92 76.32 95.9 C 75.47 97.03 73.78 97.59 72.37 97.59 Z"
};

// Initial Load
if(window.innerWidth<  900){
    buildBlogCarousel();
}

// When resizing
window.addEventListener('resize', function(){
    if(window.innerWidth >= 900){
        destroyBlogCarousel();
    }
    else if(window.innerWidth < 900){
        buildBlogCarousel();
    }
});

function buildBlogCarousel(){
    activeCarousels = [];

    for(let i = 0, length3 = carousels.length; i < length3; i++){
        var flkty = new Flickity( carousels[i], carouselOptions);

        activeCarousels.push( flkty );
    }
}

function destroyBlogCarousel(){
    for(let i = 0, length3 = activeCarousels.length; i < length3; i++){
        activeCarousels[i].destroy();
    }
}